import { ComponentWrapper, Container, TextWrapper } from 'components/common';
import { H3 } from 'components/common/Typography';
import React from 'react';

export const AboutUs = () => (
  <ComponentWrapper large as={Container} id="about-us">
    <H3>O nas</H3>

    <TextWrapper left>
      <br />
      Jesteśmy nowoczesną agencją marketingową i domem produkcyjnym, który łączy kreatywność
      <br />i strategię z najwyższą jakością produkcji wideo.
      <br />
      <br />
      Specjalizujemy się w tworzeniu angażujących kampanii marketingowych, które działają
      <br />– zwłaszcza tam, gdzie serca widzów biją szybciej: na TikToku oraz na Instagramie i YouTube.
      <br />
      <br />
      <br />
      <p style={{ textAlign: 'center' }}>Zapraszamy do współpracy.</p>
    </TextWrapper>
  </ComponentWrapper>
);
